import axios from 'axios';

import setupAxiosInstance from './setupAxiosInstance';

const axiosInstance = setupAxiosInstance(axios.create(), { retries: 3 });

export * from 'axios'; // get all the types
export default axiosInstance;
